import { Variant } from "@flypengine/myFlyp-lib"
import * as M from "../Model/feedbackModel"
import { pipe } from "fp-ts/function"
import { cmd } from "elm-ts"
import * as E from "fp-ts/Either"
import * as O from "fp-ts/Option"

export const initModel: M.Model = E.left("Not Attempted")

export const initCmd: cmd.Cmd<M.Msg> = cmd.of(M.Msg.init())

export const update: <msg>(
  config: M.Config<msg>
) => (msg: M.Msg) => (model: M.Model) => [M.Model, cmd.Cmd<msg>] =
  config => msg => model =>
    pipe(
      msg,
      Variant.caseOf({
        [M._init]: () => [model, cmd.of(config.dealFeedbackMsg())],
        [M._lastFocused]: lastFocused => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, lastFocused }))
          ),
          cmd.none,
        ],
        [M._modalContents]: modalContents => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, modal: modalContents }))
          ),
          pipe(
            modalContents,
            O.match(
              () =>
                pipe(
                  model,
                  E.match(
                    () => cmd.none,
                    prevModel =>
                      pipe(
                        prevModel.lastFocused,
                        O.match(
                          () => cmd.none,
                          lastFocused => {
                            document.getElementById(lastFocused)?.focus()
                            return cmd.none
                          }
                        )
                      )
                  )
                ),
              () => cmd.none
            )
          ),
        ],
      })
    )
